
import { mdiCardsHeart } from "@mdi/js";
import ProfileMenuV2 from "@/components/v2/common/profiles/profile-menu-v2.vue";
import IconMessage from "@/components/icons/IconMessage.vue";

export default {
  name: "ProfileActions",

  components: {
    ProfileMenuV2,
    IconMessage,
  },

  props: {
    profile: {
      type: Object,
      required: true,
    },

    inFavorites: {
      type: Boolean,
      default: false,
    },

    isFavoriteProcessing: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      mdiCardsHeart,
    };
  },

  methods: {
    addToFavorite() {
      console.log("addToFavorite");

      if (this.$auth.loggedIn) {
        this.$emit("favoriteClicked", {
          ...this.profile,
          isFavorite: this.inFavorites,
        });
      } else if (window.innerWidth < 1024) {
        this.$root.$emit("sign-in-drawer:open");
      } else {
        this.$router.push({ name: "auth-signin" });
      }
    },

    openPmModal() {
      if (this.$auth.loggedIn) {
        this.isMenuOpen = false;
        this.$root.$emit("sendPM", this.profile);
      } else if (window.innerWidth < 1024) {
        this.$root.$emit("sign-in-drawer:open");
      } else {
        this.$router.push({ name: "auth-signin" });
      }
    },

    openBookMe() {
      this.$root.$emit("book-me-modal:open", this.profile.slug);
    },
  },
};
